// Custom Logger Utility
const { getEnvVars } = require('../public-env-vars.js');

const logger = {
  log: function (...args) {
    const envVars = getEnvVars();
    if (envVars.NODE_ENV === 'development') {
      console.log(...args);
    }
  },
  debug: function (...args) {
    const envVars = getEnvVars();
    if (envVars.NODE_ENV === 'development') {
      console.debug(...args);
    }
  },
  warn: function (...args) {
    const envVars = getEnvVars();
    if (envVars.NODE_ENV === 'development') {
      console.warn(...args);
    }
  },
  error: function (...args) {
    const envVars = getEnvVars();
    if (envVars.NODE_ENV === 'development') {
      console.error(...args);
    }
  }
};

module.exports = logger;
module.exports.default = logger;
module.exports.__esModule = true;

// Usage Example:
// logger.log('This will only log in non-production environments');
